/**
 * @fileoverview LLC type options for W9 tax form
 * @description Provides a frozen array of LLC type options for use in W9 tax form dropdown selections.
 * Each option contains a label and value pair representing the IRS LLC tax classification types.
 */

/**
 * Frozen array of LLC type options for W9 tax form
 * @constant {Array<{label: string, value: string}>} LlcTypeOptions
 * @description Contains LLC tax classification types as defined by IRS Form W-9.
 * These options specify how the LLC should be classified for federal tax purposes.
 */
export const LlcTypeOptions = Object.freeze([
    { label: "C Corporation", value: "C" },
    { label: "S Corporation", value: "S" },
    { label: "Partnership", value: "P" }
]);
